import { VacanciesService } from './../../vacancies.service';
import { Component, OnInit, Input } from '@angular/core';
import { ScreeningFilter } from '../../../core/models';
import { Observable } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { take, map } from 'rxjs/operators';
import { NgxHotjarService } from 'ngx-hotjar';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { EmailListWithExternalAccessModalComponent } from '../email-list-with-external-access-modal/email-list-with-external-access-modal.component';

@Component({
	selector: 'app-list-filters-modal',
	templateUrl: './list-filters-modal.component.html',
	styleUrls: ['./list-filters-modal.component.scss']
})
export class ListFiltersModalComponent implements OnInit {
	@Input() vacancyId;
	filters: Observable<ScreeningFilter[]>;
	modalResult;
	public guestAccessOpen: boolean = false;

	constructor(
		private vacanciesService: VacanciesService,
		protected $hotjar: NgxHotjarService,
		private modalService: NgbModal,
		public router: Router
	) { }

	ngOnInit() {
		this.$hotjar.virtualPageView(`${environment.web_link}${this.router.url}`);
		this.filters = this.vacanciesService.getVacancyScreeningFilters(this.vacancyId);
	}

	public applyFilter(singleFilter) {
		this.modalResult = singleFilter.filters;
	}

	public removeFilter(singleFilter: ScreeningFilter) {
		this.vacanciesService.deleteVacancyScreeningFilters(this.vacancyId, singleFilter._id)
			.pipe(take(1))
			.subscribe(response => this.updateFilters(singleFilter));
	}

	private updateFilters(singleFilter: ScreeningFilter) {
		this.filters = this.filters
			.pipe(
				map(filterArray => filterArray.filter(item => item._id !== singleFilter._id))
			);
	}

	public copied(singleFilter): void {
		const url = this.router.serializeUrl(
			this.router.createUrlTree([`/public/vacancies/${this.vacancyId}/steps/${singleFilter.filters.step}/filters/${singleFilter._id}/feedback-by-step`])
		);

		window.open(url, '_blank');
	}

	public allowExternalGuestAccess(filter: any): void {
		this.guestAccessOpen = true;
		const modal = this.modalService.open(EmailListWithExternalAccessModalComponent, { size: 'lg', backdrop: false });
		modal.componentInstance.emailsFromTheExternalLinks = filter.emailsFromTheExternalLinks || [];
		modal.componentInstance.htmlDescription = `Informe os emails das pessoas que devem receber o link para o filtro ${filter.name}`;

		modal.result.then(result => {
			this.guestAccessOpen = false;
			if (result) {
				filter.emailsFromTheExternalLinks = result;
	
				this.vacanciesService.patchScreeningFilterExternalAccess(this.vacancyId, filter._id, {
					emailsFromTheExternalLinks: result
				}).subscribe(response => { })
			}
		}).catch(err => {
			this.guestAccessOpen = false;
		});
	}
}
